<template>
    <div ref="recaptcha"></div>
</template>
<style lang="scss"></style>
<script>

    export default {

        name : 'v-recaptcha',

        props : {
            action: {
                type: String,
                required : false,
            },
        },

        data() {
            return {
                key  : null,
                url  : null,
            }
        },

        methods: {

            load() {

                let self   = this,
                    script = document.createElement('script');

                script.setAttribute('src', 'https://www.google.com/recaptcha/api.js?render=' + this.key);

                script.onerror = function(){

                    self.$emit('on-error', 'Error load Recaptcha v3');
                };

                script.onload = function(){

                    grecaptcha.ready(function() {

                        grecaptcha.execute(self.key, { action: self.action }).then( function(token) {

                            axios.post(self.url, {

                                'token'      : token,

                            }).then(function(response) {

                                self.$emit('success', response.data );

                            }).catch(function(error) {

                                self.$emit(error);
                            });

                        });
                    });
                };

                document.head.appendChild(script);
            },
        },

        mounted: function () {

            let documentKey = document.head.querySelector('meta[name="google-recaptcha"]');
            let documentUrl = document.head.querySelector('meta[name="google-recaptcha-verify"]');

            this.key  = documentKey ? documentKey.content : null;
            this.url  = documentUrl ? documentUrl.content : null;

            this.load();
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/reCaptchaV3.vue